'use strict';
var novicell = novicell || {};

novicell.showPassword = novicell.showPassword || function () {

    function init() {
        showPassword();
    }

    function showPassword() {
        jQuery(".toggle-password").click(function() {
            jQuery(this).toggleClass("show");
            let input = jQuery(jQuery(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    }

    return {
        init: init,
        showPassword: showPassword
    };
}();
